export default __webpack_public_path__ + "static/media/flag-belgium.3fa20cfe.svg";